import { DISH_REVIEW } from '../../constants'

const getDishReviewBreadcrumbItemByTaskId = dishReviewTaskId => ({
  path: `/tasks/dish-review/${dishReviewTaskId}`,
  type: DISH_REVIEW,
  name: 'Dish Review',
})

export default getDishReviewBreadcrumbItemByTaskId
